import axios from "axios";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import Swal from "sweetalert2";
import api, { injectLogout } from "../js/axios";

export const AuthContext = createContext();

export function AuthContextProvider({children}){
   const [isAuthenticated,setIsAuthenticated]  = useState(localStorage.getItem('MY_AUTH_LATITUD') ?? false);
   const [identity, setIdentity]               = useState(localStorage.getItem('IDENTITY') ?? null);
   const [nominaNombre, setNominaNombre]       = useState(localStorage.getItem('NOMINA_NOMBRE') ?? null);
   const [nominaID, setNominaID]               = useState(localStorage.getItem('NOMINA_ID') ?? null);
   const [nominaDNI, setNominaDNI]             = useState(localStorage.getItem('NOMINA_DNI') ?? null);
   

   const login = useCallback(function(user){
      api
      .post(`${process.env.REACT_APP_API_URL}/web/login`, user)
      .then((payload) => {
         if (payload.data.status) {
               localStorage.setItem("MY_AUTH_LATITUD", true);
               localStorage.setItem("IDENTITY", payload.data.identity);
               localStorage.setItem("NOMINA_NOMBRE", payload.data.nominaNombre);
               localStorage.setItem("NOMINA_ID", payload.data.nominaID);
               localStorage.setItem("NOMINA_DNI", payload.data.nominaDNI);
               setIsAuthenticated(true);
               setIdentity(payload.data.identity);
               setNominaNombre(payload.data.nominaNombre);
               setNominaID(payload.data.nominaID)
               setNominaDNI(payload.data.nominaDNI);
         }else{
               Swal.fire({
                  icon: payload.data.icon,
                  title: payload.data.title,
                  html: payload.data.message,
                  showConfirmButton: true,
                  confirmButtonText: "Ok",
               }).then((response) => {
               });
         }
      })
      .catch((error) => {});
   },[]);

   const logout = useCallback(function () {
      localStorage.removeItem("MY_AUTH_LATITUD");
      localStorage.removeItem("IDENTITY");
      localStorage.removeItem("NOMINA_NOMBRE");
      localStorage.removeItem("NOMINA_ID");
      localStorage.removeItem("NOMINA_DNI");
      setIsAuthenticated(false);
      setIdentity(null);
      setNominaNombre(null);
      setNominaID(null);
      setNominaDNI(null);
   }, []);


   const value = useMemo(
      () => ({
         login,
         logout,
         isAuthenticated,
         identity,
         nominaNombre,
         nominaID,
         nominaDNI

      }),
      [login,logout,isAuthenticated,identity,nominaNombre,nominaID,nominaDNI]
   );

   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuthContext(){
   return useContext(AuthContext);
}